import type { PilotLinkState, PilotRow } from '@antoja/shared';
import { t } from '../i18n';
import type { IconName } from '../icons';

// Keeps a number and its unit on one line.
const NBSP = '\u00a0';

export const linkStateIcons: Record<PilotLinkState, IconName> = {
  linked: 'check',
  unmatched: 'none',
  doubtful: 'conflict',
  not_in_fsq: 'cross',
};

/** "Escogido n.º 3" or "Reserva n.º 2". */
export function roleLabel(row: Pick<PilotRow, 'role' | 'listRank'>): string {
  return t(`pilot.role.${row.role}`, { rank: row.listRank });
}

const percent = new Intl.NumberFormat('es-CO', { style: 'percent', maximumFractionDigits: 0 });
const meters = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
const kilometers = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 1 });

/** 0.82 → "82 %", as Spanish writes it. */
export function formatSimilarity(similarity: number): string {
  return percent.format(similarity);
}

/** Rounded first, then the unit: 352.4 → "350 m", 996 → "1 km", 1240 → "1,2 km". */
export function formatDistance(distance: number): string {
  const tens = Math.round(distance / 10) * 10;
  if (tens < 1000) return `${meters.format(tens)}${NBSP}m`;
  return `${kilometers.format(Math.round(distance / 100) / 10)}${NBSP}km`;
}

const SOURCES = { fsq_os: 'pilot.source.fsq', business_website: 'pilot.source.website' } as const;

/** Where a pilot place's status comes from, in words. */
export function sourceLabel(code: string | null): string {
  if (code === 'fsq_os' || code === 'business_website') return t(SOURCES[code]);
  return t('pilot.source.other');
}
